<template>
  <div
    id="page-login"
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                src="@/assets/images/pages/login.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Login</h4>
                  <p>
                    Bienvenido, porfavor inicia sesion para acceder a tu cuenta.
                  </p>
                </div>

                <div>
                  <vs-input
                    v-model="email"
                    v-validate="'required'"
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Email"
                    class="w-full"
                  />
                  <span
                    v-show="errors.has('email')"
                    class="text-danger text-sm"
                    >{{ errors.first("email") }}</span
                  >

                  <vs-input
                    v-model="password"
                    v-validate="'required'"
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    class="w-full mt-6"
                  />
                  <span
                    v-show="errors.has('password')"
                    class="text-danger text-sm"
                    >{{ errors.first("password") }}</span
                  >

                  <div class="flex flex-wrap justify-end my-5">
                    <!-- TODO: Validate remember function with firebase and backend (also register) -->
                    <!-- <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Recordarme</vs-checkbox> -->
                    <router-link
                      :to="{
                        name: 'page-forgot-password'
                      }"
                    >
                      ¿Olvidaste tu contraseña?
                    </router-link>
                  </div>
                  <vs-button
                    type="border"
                    class="w-full mt-2 md:w-5/12"
                    :to="{ name: 'page-register' }"
                    >Registrarme</vs-button
                  >
                  <vs-button
                    class="w-full mt-2 md:w-5/12 md:float-right"
                    @keyup.enter="submit"
                    @click.prevent="submit"
                    >Continuar</vs-button
                  >

                  <vs-divider>O</vs-divider>

                  <div
                    class="social-login-buttons flex flex-wrap mt-4 md:justify-start justify-center"
                  >
                    <!-- facebook -->
                    <div
                      class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                      @click="socialLogin('facebook')"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fab"
                        data-icon="facebook-f"
                        class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 264 512"
                      >
                        <path
                          fill="currentColor"
                          d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
                        />
                      </svg>
                    </div>

                    <!-- TWITTER -->
                    <div
                      class="bg-twitter pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                      @click="socialLogin('twitter')"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fab"
                        data-icon="twitter"
                        class="text-white h-4 w-4 svg-inline--fa fa-twitter fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path
                          fill="currentColor"
                          d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                        />
                      </svg>
                    </div>

                    <!-- GOOGLE -->
                    <div
                      class="bg-google pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                      @click="socialLogin('google')"
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fab"
                        data-icon="google"
                        class="text-white h-4 w-4 svg-inline--fa fa-google fa-w-16"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 488 512"
                      >
                        <path
                          fill="currentColor"
                          d="M488 261.8C488 403.3 391.1 504 248 504 110.8 504 0 393.2 0 256S110.8 8 248 8c66.8 0 123 24.5 166.3 64.9l-67.5 64.9C258.5 52.6 94.3 116.6 94.3 256c0 86.5 69.1 156.6 153.7 156.6 98.2 0 135-70.4 140.8-106.9H248v-85.3h236.1c2.3 12.7 3.9 24.9 3.9 41.4z"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { Validator } from "vee-validate";
const dict = {
  custom: {
    email: {
      required: "Este campo es requerido"
    },
    password: {
      required: "Este campo es requerido"
    }
  }
};

// register custom messages
Validator.localize("en", dict);

export default {
  data() {
    return {
      email: "",
      password: ""
    };
  },
  methods: {
    socialLogin(provider) {
      this.$vs.loading({
        type: "corners",
        background: "rgba(45, 166, 179, 1)",
        color: "rgb(255, 255, 255)"
      });
      this.$store
        .dispatch("socialAuth", {
          provider
        })
        .then(res => {
          this.$vs.loading.close();
        })
        .catch(err => {
          console.log("algo paso");
        });
    },
    submit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$vs.loading({
            type: "corners",
            background: "rgba(45, 166, 179, 1)",
            color: "rgb(255, 255, 255)"
          });
          this.$store
            .dispatch("userLogin", {
              email: this.email,
              password: this.password
            })
            .then(res => {
              if (res) {
                const data = res.data;
                if (
                  Object.entries(data).length === 0 &&
                  data.constructor === Object
                ) {
                  this.$router.push("/auth/register/suscribe");
                  this.$vs.loading.close();
                } else {
                  this.$store.commit("setUser", data);
                  this.$store.commit("updateSubscription", data.is_subscribed);
                  this.$router.push("/");
                  this.$vs.loading.close();
                }
              } else {
                this.$vs.loading.close();
              }
            })
            .catch(err => {
              let error = JSON.stringify(err);

              switch (error.code) {
                case "auth/invalid-email":
                  this.openAlert("danger", "Email invalido");
                  this.$vs.loading.close();
                case "auth/user-not-found":
                  this.openAlert("danger", "Usuario / Contraseña incorrecto");
                  this.$vs.loading.close();
                case "auth/wrong-password":
                  this.openAlert("danger", "Usuario / Contraseña incorrecto");
                  this.$vs.loading.close();
                default:
                  this.openAlert(
                    "danger",
                    "Ocurrio un error, porfavor intenta mas tarde, si persiste, contacta a soporte."
                  );
                  this.$vs.loading.close();
                  break;
              }
            });
        } else {
          this.openAlert("danger", "Todos los campos son requeridos");
        }
      });
    },
    openAlert(color, message) {
      this.colorAlert = color;
      this.$vs.dialog({
        color: this.colorAlert,
        title: `Aviso`,
        text: message || "Contacta al soporte"
      });
    }
  }
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #4267b2;
    }
    .bg-twitter {
      background-color: #1da1f2;
    }
    .bg-google {
      background-color: #db4437;
    }
  }
}
</style>
